import { render, staticRenderFns } from "./VerifyInfo.vue?vue&type=template&id=436a41a8&"
import script from "@/controllers/ap/teacher/homework/VerifyInfo?v=3.1?vue&type=script&lang=ts&"
export * from "@/controllers/ap/teacher/homework/VerifyInfo?v=3.1?vue&type=script&lang=ts&"
import style0 from "@/assets/css/main.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports